export default __webpack_public_path__ + "static/email-robot-1e48363e947320c54fe3671a1135fbba.gif";